import axiosService from "./service";
import {
  SIGN_IN_SUCCESS,
  GET_PROFILE_DETAILS,
  SIGN_IN_ERROR,
  SET_ACTIVE_PAGE,
  SELECT_PORTAL_TYPE,
  SHOW_GLOBAL_APP_BAR,
} from "./actionTypes";
import { apiPostDispatch } from "../../utils/reduxUtil";
import { MODULE_NAME } from "./constants";
import { ApiEndpoints } from "../../utils/utility";
import viewUtility from "../../utils/viewUtility";
import StorageUtil from "../../utils/storageUtil";

export function login(username, password) {
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("userName", username);
      formData.append("password", password);
      const res = await axiosService.signin(formData);
      if (res && res.data) {
        if (res.data.status === "SUCCESS") {
          dispatch({
            type: SIGN_IN_SUCCESS,
            data: res.data.data,
          });
        } else {
          dispatch({
            type: SIGN_IN_ERROR,
            data: res.data.error,
          });
        }
      }
    } catch (error) {
      throw error;
    }
  };
}
export const setPortalActivePage = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SET_ACTIVE_PAGE,
      data: data,
    });
  };
};

export const selectPortalType = (data) => {
  return {
    type: SELECT_PORTAL_TYPE,
    data: data,
  };
};

export const getProfileDetails = (data) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("userId", StorageUtil.getObject(viewUtility.USER_DATA).id);
    const response = await apiPostDispatch(dispatch, {
      type: GET_PROFILE_DETAILS,
      endPoint: ApiEndpoints.PROFILE_DETAILS,
      actionKey: "getProfileDetails",
      data: formData,
      module: MODULE_NAME,
    });
    return response;
  };
};

export const setAppBarStatus = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SHOW_GLOBAL_APP_BAR,
      data: data,
    });
  };
};

export default {};
